// api/CustomizeLargeScreen
import request from '@utils/request'

const url = 'api/CustomizeLargeScreen/'

/**
 * 获取费尼亚电站大屏数据
 */
export function GetFeiNiYaLargeScreen () {
  return request({
    url: url + 'QueryFeiNiYaLargeScreen',
    method: 'post'
  })
}

